<template lang="pug">
  b-modal.email-detail-modal(ref="modal" title="Detalle del Correo" ok-only ok-title="Cerrar")
    div(v-if="email")
      strong Empresa
      .mb-2 {{email.business ? email.business.name : 'sin empresa'}}
      strong Asunto
      .mb-2 {{email.subject}}
      strong Emails
      .mb-2 {{email.emails.replaceAll(',', ', ')}}
      .d-flex
        strong Contenido
        b-button.ml-2(
          v-clipboard="() => email.content"
          @success="$root.$bvToast.toast('Copiado al portapapeles', { title: 'Ok!', variant: 'success' })"
          size="sm"
          variant="light"
        )
          font-awesome-icon.copy(:icon="['far', 'copy']" size="lg")
      .mb-2 {{email.content}}
      strong Respuesta de sendinblue
      div {{email.sendinblueResponse}}
</template>

<script>
export default {
  data () {
    return {
      email: null
    }
  },
  methods: {
    showModal (options) {
      this.email = options.email
      this.$refs.modal.show()
    }
  }
}
</script>
